import { render, staticRenderFns } from "./BeiguoNotify.vue?vue&type=template&id=55157575&scoped=true"
import script from "./BeiguoNotify.vue?vue&type=script&lang=js"
export * from "./BeiguoNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55157575",
  null
  
)

export default component.exports